import { createComponentStore } from '../../utils/createComponentStore';

const getDefaultData = () => ({
  mode: 'all',
  orConditions: {},
});

function createRelatedComponentItem(componentId) {
  return {
    componentId: componentId,
    componentData: null,
    userId: null,
    type: null,
    name: '',
    databaseId: null,
  };
}

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'merge_workflow',
  endpoint: 'merge_workflow',
  registryKey: 'merge-workflow',
  initData: getDefaultData,

  onLoadData: (rawData) => {
    const data = { ...rawData };
    // v1 compat: function → mode, condition → orConditions
    if (data.function && !data.mode) { data.mode = data.function; delete data.function; }
    if (data.condition && !data.orConditions) { data.orConditions = data.condition; delete data.condition; }
    return data;
  },

  extraState: () => ({
    error: false,
    relatedComponents: [],
  }),

  extraActions: (set, get) => ({
    setFunction: (funct) =>
      set((s) => ({
        data: { ...s.data, mode: funct },
      })),

    setFunctionDefaultValue: () => {
      const fn = get().data.mode;
      if (fn === 'any' || fn === 'all') {
        set((s) => ({ data: { ...s.data, orConditions: { OR: [] } } }));
      } else if (fn === 'or_and') {
        set((s) => ({ data: { ...s.data, orConditions: { OR: [{ AND: [] }] } } }));
      }
    },

    getFunction: () => get().data.mode,

    getCondition: () => get().data.orConditions,

    setCondition: (orConditions) =>
      set((s) => ({ data: { ...s.data, orConditions } })),

    addCondition: (index) => {
      const fn = get().data.mode;
      const data = JSON.parse(JSON.stringify(get().data));

      if (fn === 'any' || fn === 'all') {
        if (!data.orConditions || !data.orConditions.OR) {
          data.orConditions = { OR: [] };
        }
        data.orConditions.OR.push('null');
      } else if (fn === 'or_and' && index >= 0) {
        if (!data.orConditions || !data.orConditions.OR) {
          if (fn === 'any' || fn === 'all') {
            data.orConditions = { OR: [] };
          } else if (fn === 'or_and') {
            data.orConditions = { OR: [{ AND: [] }] };
          }
        }
        data.orConditions.OR[index].AND.push('null');
      }
      set({ data });
    },

    deleteCondition: (index, orConditionIndex) => {
      const fn = get().data.mode;
      const data = JSON.parse(JSON.stringify(get().data));

      if (fn === 'any' || fn === 'all') {
        if (data.orConditions && data.orConditions.OR) {
          data.orConditions.OR.splice(index, 1);
        }
      } else if (fn === 'or_and') {
        data.orConditions.OR[orConditionIndex].AND.splice(index, 1);
        if (data.orConditions.OR[orConditionIndex].AND.length === 0) {
          data.orConditions.OR.splice(orConditionIndex, 1);
        }
      }
      set({ data });
    },

    setConditionValue: (index, value, orConditionIndex) => {
      const fn = get().data.mode;
      const data = JSON.parse(JSON.stringify(get().data));

      if (fn === 'any' || fn === 'all') {
        data.orConditions.OR[index] = value;
      } else if (fn === 'or_and') {
        data.orConditions.OR[orConditionIndex].AND[index] = value;
      }
      set({ data });
    },

    addORBlock: () => {
      const fn = get().data.mode;
      if (fn === 'or_and') {
        const data = JSON.parse(JSON.stringify(get().data));
        data.orConditions.OR.push({ AND: [] });
        set({ data });
      }
    },

    setRelatedComponents: (relatedComponents) =>
      set({ relatedComponents: [...relatedComponents] }),

    getRelatedComponents: () => get().relatedComponents,

    setFocus: (index) => set({ position: index }),

    updateComponentData: (newData) => {
      if (!newData) return;
      // v1 compat
      if (newData.function && !newData.mode) { newData.mode = newData.function; delete newData.function; }
      if (newData.condition && !newData.orConditions) { newData.orConditions = newData.condition; delete newData.condition; }
      const relatedComponents = [];
      if ((newData.mode === 'any' || newData.mode === 'all') && newData.orConditions && newData.orConditions.OR) {
        for (let i = 0; i < newData.orConditions.OR.length; i++) {
          relatedComponents.push(createRelatedComponentItem(newData.orConditions.OR[i]));
        }
      } else if (
        newData.mode === 'or_and' &&
        newData.orConditions &&
        newData.orConditions.OR &&
        newData.orConditions.OR.length === 1 &&
        newData.orConditions.OR[0].AND
      ) {
        for (let i = 0; i < newData.orConditions.OR[0].AND.length; i++) {
          relatedComponents.push(createRelatedComponentItem(newData.orConditions.OR[0].AND[i]));
        }
      }
      set({ data: newData, relatedComponents });
    },

    keyAuto: () =>
      'mw' + (Math.floor(Math.random() * 90000000) + 10000).toString(),

    getDefaultData,

    getTemplate: () => {
      const { componentId, name, data, type, lastModified, relatedComponents } = get();
      return {
        componentId,
        name,
        data: data ? JSON.parse(JSON.stringify(data)) : getDefaultData(),
        type,
        lastModified,
        relatedComponents: JSON.parse(JSON.stringify(relatedComponents)),
      };
    },
  }),
});

export { createStore as createMergeWorkflowStore };
export const getMergeWorkflowStore = getStore;
export default defaultStore;
